
	import { Observer } from 'mobx-vue';
	import { Component, Prop, Vue } from 'vue-property-decorator';

	@Observer
	@Component({
		components: {}
	})
	export default class CategoryContainer extends Vue {
		@Prop({ required: true }) readonly categoryTitle!: string;
	}
